import { CSSProperties, ReactNode, useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/material';

type P = {
  children: ReactNode;
  modifyComponent: ReactNode;
  isOwner: boolean;
  style?: CSSProperties;
  mobileMode?: boolean;
};

const ModifyLayout = ({
  children,
  modifyComponent,
  isOwner,
  style,
  mobileMode = false,
}: P) => {
  const [isFocused, setIsFocused] = useState(mobileMode ?? false);
  const ref = useRef<HTMLDivElement>(null);
  const mouseDown = () => setIsFocused(false);

  // 컴포넌트 외부를 클릭했을 때 focus 상태를 해제하는 로직
  useEffect(() => {
    // 전역에서 pointerdown 이벤트(마우스/터치 등)를 감지하는 핸들러
    const handlePointerDown = (event: PointerEvent) => {
      // 마우스 이벤트인 경우, 좌클릭(0번 버튼)이 아닌 클릭은 무시
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      const target = event.target as HTMLElement;

      // ref.current 바깥 클릭 mouseDown 호출
      if (ref.current && !ref.current.contains(target)) {
        // 내부 state에서 isFocused를 false로 만들어 포커스를 해제하는 역할
        !mobileMode && mouseDown();
      }
    };

    document.addEventListener('pointerdown', handlePointerDown);
    return () => {
      document.removeEventListener('pointerdown', handlePointerDown);
    };
  }, [ref]);

  return (
    <>
      <Container style={{ ...style }} isOwner={isOwner} ref={ref}>
        {isOwner && isFocused ? (
          <Box onClick={() => setIsFocused(true)}>{modifyComponent}</Box>
        ) : (
          <StyledLayout isOwner={isOwner} onClick={() => setIsFocused(true)}>
            {children}
          </StyledLayout>
        )}
      </Container>
    </>
  );
};

export default ModifyLayout;

const Container = styled.div<{ isOwner: boolean }>`
  position: relative;
  cursor: ${({ isOwner }) => (isOwner ? 'pointer' : 'auto')};
`;

const StyledLayout = styled.div<{ isOwner: boolean }>`
  :hover {
    background-color: ${({ isOwner }) => (isOwner ? 'var(--dk-bg-subtle, #F9FAFB)' : 'var(--dk-bg, #fff)')};
  }
  :active {
    background-color: ${({ isOwner }) => (isOwner ? 'var(--dk-bg-muted, #F3F5F6)' : 'var(--dk-bg, #fff)')};
  }
`;
